import { Trans, useTranslation } from 'react-i18next';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';
import { Badge, MyLink } from '@scramble/ui';
import { prettyMoney } from '@scramble/utils';
import { useGetInvestedInGroupsStats } from '@/query/queries/investing/useGetInvestedInGroupsStats';
import { APP_LINKS } from '@/helpers/links';
import 'react-circular-progressbar/dist/styles.css';
import s from './index.module.scss';

export function InvestedInGroupsStats() {
  const { t } = useTranslation();
  const { data } = useGetInvestedInGroupsStats();

  if (!data) {
    return null;
  }

  const groups = data.map(group => ({
    ...group,
    percentage:
      Math.floor(
        ((group.full_amount - group.remaining_amount) / group.full_amount) *
          100,
      ) || 0,
  }));

  return (
    <div className={s.wrapper}>
      <h5 className={s.title}>
        {t('investing:inv_group_stats.invested_to_round')}
      </h5>
      <div className={s.groups}>
        {groups.map(group => (
          <div key={group.group_title} className={s.group}>
            <div className={s.content}>
              <div className={s.top}>
                <div className={s.value}>
                  {t('investing:inv_group_stats.left_out_of', {
                    start: prettyMoney(group.remaining_amount),
                    end: prettyMoney(group.full_amount),
                  })}
                </div>
                {!!group.reserve_amount && (
                  <div className={s.loyalty}>
                    <Trans
                      ns="investing"
                      i18nKey="investing:inv_group_stats.includes_reserve"
                      values={{
                        reserve_amount: prettyMoney(group.reserve_amount),
                      }}
                      components={{
                        Link: (
                          <MyLink href={APP_LINKS.loyaltyProgram} underline />
                        ),
                      }}
                    />
                  </div>
                )}
              </div>
              <Badge
                type="neutral"
                appearance="filled"
                size="medium"
                label={group.group_title}
              />
            </div>
            <div className={s.progress}>
              <CircularProgressbarWithChildren
                value={group.percentage}
                strokeWidth={4}
                styles={buildStyles({
                  strokeLinecap: 'butt',
                  pathColor:
                    group.percentage <= 75
                      ? 'var(--Border-Success-Primary-Base, #60A92D)'
                      : 'var(--Border-Danger-Primary-Base, #E43F3F)',
                  trailColor: 'var(--Bg-Neutral-Primary-Light, #F4F4F5)',
                })}
              >
                <div className={s.percentage}>{group.percentage}%</div>
              </CircularProgressbarWithChildren>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
